import { useState, useEffect, useRef } from 'react';

const CameraTest = ({ onTestComplete }) => {
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(null);
  const [devices, setDevices] = useState([]);
  const videoRef = useRef(null);

  useEffect(() => {
    checkDevices();
  }, []);

  const checkDevices = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      setDevices(videoDevices);
      console.log('Dispositivos de video encontrados:', videoDevices);
    } catch (err) {
      console.error('Error al enumerar dispositivos:', err);
      setError('No se pudieron enumerar los dispositivos');
    }
  };

  const startCamera = async () => {
    try {
      setError(null);
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: 'user'
        },
        audio: true
      });
      
      setStream(mediaStream);
      
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
      
      console.log('Cámara iniciada correctamente');
    } catch (err) {
      console.error('Error al iniciar cámara:', err);
      setError(`Error al acceder a la cámara: ${err.message}`);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
    }
  };

  const handleTestComplete = () => {
    stopCamera();
    if (onTestComplete) {
      onTestComplete();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Prueba de Cámara</h2>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            <strong>Error:</strong> {error}
          </div>
        )}

        <div className="mb-4">
          <h3 className="font-semibold text-gray-700 mb-2">Dispositivos de Video Encontrados:</h3>
          <ul className="text-sm text-gray-600">
            {devices.map((device, index) => (
              <li key={device.deviceId} className="mb-1">
                {index + 1}. {device.label || `Cámara ${index + 1}`}
              </li>
            ))}
          </ul>
        </div>

        <div className="mb-4">
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className="w-full max-w-md mx-auto border border-gray-300 rounded-lg"
            style={{ display: stream ? 'block' : 'none' }}
          />
        </div>

        <div className="flex gap-4 justify-center">
          {!stream ? (
            <button
              onClick={startCamera}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Probar Cámara
            </button>
          ) : (
            <button
              onClick={stopCamera}
              className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Detener Cámara
            </button>
          )}
          
          <button
            onClick={handleTestComplete}
            className="bg-gray-600 text-white px-6 py-2 rounded-lg hover:bg-gray-700 transition-colors"
          >
            Cerrar
          </button>
        </div>

        <div className="mt-4 text-sm text-gray-600">
          <p><strong>Instrucciones:</strong></p>
          <ul className="list-disc list-inside mt-2">
            <li>Haz clic en "Probar Cámara" para verificar que tu cámara funciona</li>
            <li>Si ves tu imagen, la cámara está funcionando correctamente</li>
            <li>Si hay errores, verifica los permisos del navegador</li>
            <li>Asegúrate de que no hay otras aplicaciones usando la cámara</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CameraTest; 